import { useSnackbar } from "notistack";
import { useContext, useState } from "react";
import Swal from "sweetalert2";
import { config as url } from "../../common/config";
import AlertNotistack from "../../components/molecules/AlertNotistack";
import useAPI from "../../hooks/useAPI";
import AuthContext from "../Auth/authContext";
import FetchDataContext from "./fetchDataContext";

const FetchDataState = (props) => {
	const {
		getDataTable,
		postData,
		postFormData,
		delData,
		putData,
		getOptionAll,
	} = useAPI();
	const authContext = useContext(AuthContext);
	const { tableRef, tableRefCompare } = authContext;
	const { enqueueSnackbar } = useSnackbar();
	const [stateOption, setStateOption] = useState({
		option1: "",
		option2: "",
		optionResult: "",
		optionGroupIssue: "",
		optionUserIssue: "",
		optionStatusIssue: "",
		optionSLA: "",

	});
	const [incidentOption, setStateIncident] = useState({
		optionVehicles: "",
		optionFactors: "",
		optionFactorsDetails: "",
		optionIncidentType: "",
		optionIncidentTypeDetails: "",
	})
	const [singleOption, setSingleOption] = useState("");
	const [singleDashboard, setSingleDashboard] = useState("");

	const refreshData = () => {
		tableRef.current && tableRef.current.onQueryChange();
	};
	const refreshDataCompare = () => {
		tableRefCompare.current && tableRefCompare.current.onQueryChange();
	};

	const snackBarError = (message) => {
		return enqueueSnackbar(message, AlertNotistack("error"));
	};

	const snackBarResult = (result) => {
		if (result.status === "error") {
			return snackBarError(result.message);
		}
		if (!result) enqueueSnackbar("Server Error", AlertNotistack("error"));
		if (!result.data)
			enqueueSnackbar(result.message, AlertNotistack(result.status));
		return result;
	};

	const getDataTables = (props) => {
		const { url, state = "", type = "" } = props;
		return (query) =>
			new Promise((resolve, reject) => {
				const { pageSize, page, search } = query;
				getDataTable({
					url: `${url}`,
					pageSize: pageSize,
					page: page,
					search: search,
					state: state,
					type: type,
				})
					.then((result) => {
						if (result.status === "success") {
							snackBarResult(result);
							if (result.data) {
								resolve({
									data: result.data.data,
									page: result.data.page - 1,
									totalCount: Number(result.data.total),
								});
							} else {
								resolve({
									data: [],
									page: 1,
									totalCount: 0,
								});
							}
							return result;
						} else {
							return snackBarError(result.message);
						}
					})
					.catch((error) => snackBarError(error.message));
			});
	};

	const addData = async (url, data, handleCloseOpen) => {
		try {
			const result = await postData(`${url}`, data);
			snackBarResult(result);
			setTimeout(() => {
				if (result.status === "success") handleCloseOpen();
			}, 1000);
			refreshData();
			return result;
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const addDataForm = async (url, FormData, handleCloseOpen) => {
		try {
			const result = await postFormData(`${url}`, FormData);
			snackBarResult(result);
			setTimeout(() => {
				if (result.status === "success")
					handleCloseOpen() ? handleCloseOpen() : refreshData();
			}, 1000);
			refreshData();
			return result;
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const deleteData = async (url, nameDelete, body) => {
		try {
			Swal.fire({
				type: "success",
				title: `Anda yakin ingin Hapus ${nameDelete ? nameDelete : body.id}? `,
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Tidak",
			}).then(async (res) => {
				if (res.isConfirmed) {
					const result = await delData(`${url}`, body);
					snackBarResult(result);
					setTimeout(() => {
						if (result.status === "success") refreshData();
					}, 1000);
					return result;
				}
			});
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const updateData = async (url, data, handleCloseOpen) => {
		try {
			const result = await putData(`${url}`, data);
			snackBarResult(result);
			setTimeout(() => {
				if (result.status === "success") handleCloseOpen();
			}, 1000);
			refreshData();
			return result;
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const MultipleHandleOptions = async ({ type = "", params }) => {
		let URI = `${url.optionMaster}`;
		let res1;
		let res2;
		let result;

		try {
			if (type === "usertorole") {
				res1 = await getOptionAll(`${URI}/layanan`);
				res2 = await getOptionAll(`${URI}/role`);
				setStateOption({
					...stateOption,
					option1: res1.data,
					option2: res2.data,
				});
				if (params.idlayanan && params.idrole) {
					result = await getOptionAll(
						`${URI}/r_user?idlayanan=${params.idlayanan}&idrole=${params.idrole}`
					);
					setStateOption({
						...stateOption,
						optionResult: result.data,
					});
					return result.data;
				}
			}

			if (type === "usertogroup") {
				res1 = await getOptionAll(`${URI}/layanan`);
				res2 = await getOptionAll(`${URI}/group`);
				setStateOption({
					...stateOption,
					option1: res1.data,
					option2: res2.data,
				});
				if (params.idlayanan && params.idgroup) {
					result = await getOptionAll(
						`${URI}/group_user?idlayanan=${params.idlayanan}&idgroup=${params.idgroup}`
					);
					setStateOption({
						...stateOption,
						optionResult: result.data,
					});
					return result.data;
				}
			}
		} catch (error) {
			return snackBarError(error);
		}
	};

	// const MultiHandleOptionsTask = async ({ params }) => {
	// 	let URI = `${url.optionMaster}`;
	// 	let res1;
	// 	let res2;
	// 	let result;
	// 	let resultGroup;
	// 	let resultUsers;
	// 	let resultStatus;
	// 	let resultVehicles;
	// 	let resultFactors;
	// 	let resultFactorDetails;
	// 	let resultIncidentType;
	// 	let resultIncidentTypeDetails;

	// 	try {
	// 		res1 = await getOptionAll(`${URI}/layanan_issue?id=${params.id}`);
	// 		res2 = await getOptionAll(`${URI}/status`);
	// 		resultVehicles = await getOptionAll(`${URI}/vehicle`);
	// 		resultFactors = await getOptionAll(`${URI}/accident/factor`);
	// 		resultIncidentType = await getOptionAll(`${URI}/accident/type`)

	// 		setStateOption({
	// 			...stateOption,
	// 			option1: res1.data,
	// 			option2: res2.data,

	// 		});

	// 		setStateIncident({
	// 			...incidentOption,
	// 			optionVehicles: resultVehicles?.data,
	// 			optionFactors: resultFactors?.data,
	// 			optionIncidentType: resultIncidentType?.data,
	// 		})

	// 		if (params?.idIncidentCause) {
	// 			resultFactorDetails = await getOptionAll(`${URI}/accident/factor/${params.idIncidentCause}`);

	// 			setStateIncident({
	// 				...incidentOption,
	// 				optionFactorsDetails: resultFactorDetails?.data,
	// 			})
	// 		}

	// 		if (params?.idIncidentType) {
	// 			resultIncidentTypeDetails = await getOptionAll(`${URI}/accident/type/${params.idIncidentType}`);

	// 			setStateIncident({
	// 				...incidentOption,
	// 				optionIncidentTypeDetails: resultIncidentTypeDetails?.data,
	// 			})
	// 		}

	// 		if (params?.idlayanan) {
	// 			result = await getOptionAll(
	// 				`${URI}/kategori?idlayanan=${params.idlayanan}`
	// 			);
	// 			resultGroup = await getOptionAll(
	// 				`${URI}/group_issue?idlayanan=${params.idlayanan}`
	// 			);
	// 			resultUsers = await getOptionAll(
	// 				`${URI}/user_issue?idlayanan=${params.idlayanan}`
	// 			);
	// 			resultStatus = await getOptionAll(
	// 				`${URI}/status_issue?idlayanan=${params.idlayanan}`
	// 			);

	// 			setStateOption({
	// 				...stateOption,
	// 				optionResult: result?.data,
	// 				optionGroupIssue: resultGroup?.data,
	// 				optionUserIssue: resultUsers?.data,
	// 				optionStatusIssue: resultStatus?.data,
	// 			});
	// 		}
	// 		if (params?.idkategori) {
	// 			let resultSLA = await getOptionAll(
	// 				`${URI}/sla?idkategori=${params.idkategori}&idprioritas=${params.idpriority}`
	// 			);
	// 			setStateOption({
	// 				...stateOption,
	// 				optionSLA: resultSLA?.data?.sla,
	// 			});
	// 		}
	// 	} catch (error) {
	// 		return snackBarError(error.message);
	// 	}
	// };

	const MultiHandleOptionsTask = async ({ params }) => {
		let URI = `${url.optionMaster}`;
		let res1;
		let res2;
		let result;
		let resultGroup;
		let resultUsers;
		let resultStatus;
		let resultVehicles;
		let resultFactors;
		let resultFactorDetails;
		let resultIncidentType;
		let resultIncidentTypeDetails;

		try {
			res1 = await getOptionAll(`${URI}/layanan_issue?id=${params.id}`);
			res2 = await getOptionAll(`${URI}/status`);
			resultVehicles = await getOptionAll(`${URI}/vehicle`);
			resultFactors = await getOptionAll(`${URI}/accident/factor`);
			resultIncidentType = await getOptionAll(`${URI}/accident/type`)

			setStateOption({
				...stateOption,
				option1: res1.data,
				option2: res2.data,
			});

			setStateIncident(prev => ({
				...prev,
				optionVehicles: resultVehicles?.data,
				optionFactors: resultFactors?.data,
				optionIncidentType: resultIncidentType?.data,
			}));

			if (params?.idIncidentCause) {
				resultFactorDetails = await getOptionAll(`${URI}/accident/factor/${params.idIncidentCause}`);

				setStateIncident(prev => ({
					...prev,
					optionFactorsDetails: resultFactorDetails?.data,
				}));
			}

			if (params?.idIncidentType) {
				resultIncidentTypeDetails = await getOptionAll(`${URI}/accident/type/${params.idIncidentType}`);

				setStateIncident(prev => ({
					...prev,
					optionIncidentTypeDetails: resultIncidentTypeDetails?.data,
				}));
			}

			if (params?.idlayanan) {
				result = await getOptionAll(
					`${URI}/kategori?idlayanan=${params.idlayanan}`
				);
				resultGroup = await getOptionAll(
					`${URI}/group_issue?idlayanan=${params.idlayanan}`
				);
				resultUsers = await getOptionAll(
					`${URI}/user_issue?idlayanan=${params.idlayanan}`
				);
				resultStatus = await getOptionAll(
					`${URI}/status_issue?idlayanan=${params.idlayanan}`
				);

				setStateOption(prev => ({
					...prev,
					optionResult: result?.data,
					optionGroupIssue: resultGroup?.data,
					optionUserIssue: resultUsers?.data,
					optionStatusIssue: resultStatus?.data,
				}));
			}

			if (params?.idkategori) {
				let resultSLA = await getOptionAll(
					`${URI}/sla?idkategori=${params.idkategori}&idprioritas=${params.idpriority}`
				);
				setStateOption(prev => ({
					...prev,
					optionSLA: resultSLA?.data?.sla,
				}));
			}
		} catch (error) {
			return snackBarError(error.message);
		}
	};


	const SingleHandleOptions = async ({ path }) => {
		let URI = `${url.optionMaster}`;
		try {
			let result = await getOptionAll(`${URI}/${path}`);
			snackBarResult(result);
			setSingleOption(result.data);
			return result;
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const getDashboard = async ({ url }) => {
		try {
			let result;
			result = await getOptionAll(`${url}`);
			if (result) {
				snackBarResult(result);
				setSingleDashboard(result.data);
				return result.data;
			}
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	const getFetchData = async ({ url }) => {
		try {
			let result = await getOptionAll(`${url}`);
			// snackBarResult(result);
			return result;
		} catch (error) {
			return snackBarError(error.message);
		}
	};

	return (
		<FetchDataContext.Provider
			value={{
				getDataTables,
				addData,
				addDataForm,
				deleteData,
				updateData,
				tableRef,
				tableRefCompare,
				refreshData,
				refreshDataCompare,
				MultipleHandleOptions,
				MultiHandleOptionsTask,
				SingleHandleOptions,
				stateOption,
				setStateOption,
				incidentOption,
				setStateIncident,
				getFetchData,
				getDashboard,
				singleOption,
				setSingleOption,
				singleDashboard,
				setSingleDashboard,
			}}
		>
			{props.children}
		</FetchDataContext.Provider>
	);
};

export default FetchDataState;
